import { render, staticRenderFns } from "./AboutErov.vue?vue&type=template&id=483307fe&scoped=true&lang=html"
import script from "./AboutErov.vue?vue&type=script&lang=js"
export * from "./AboutErov.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483307fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('483307fe')) {
      api.createRecord('483307fe', component.options)
    } else {
      api.reload('483307fe', component.options)
    }
    module.hot.accept("./AboutErov.vue?vue&type=template&id=483307fe&scoped=true&lang=html", function () {
      api.rerender('483307fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AboutErov.vue"
export default component.exports